import React from "react";
import { CustomHeader } from 'react-calendar-timeline' // new
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc.js'
import timezone from 'dayjs/plugin/timezone.js'
import advancedFormat from 'dayjs/plugin/advancedFormat.js';
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(advancedFormat);

// {interval.startTime.format("ddd, MMM Do")}

/**
 * Returns the date header that will be visible in the 7 to 9 day schedule. It changes based on the size of the screen.
 * @param {*} param0 
 */
const CustomDateHeader = ({ unit, textAlign }) => {
  return (
  <CustomHeader unit={unit}>
    {({
      headerContext: { intervals },
      getRootProps,
      getIntervalProps,
      showPeriod
    }) => {
      return (
        <div {...getRootProps({ style: { height: 30, fontSize: 14 } })}>
          {intervals.map(interval => {
            const intervalStyle = {
              // height:
              lineHeight: '30px',
              textAlign: textAlign,
              border: '0.5px solid gray',
              // cursor: 'pointer',
              backgroundColor: 'darkgray',
              color: 'white',
            }
            return (
              <div
                // onClick={() => {
                //   showPeriod(interval.startTime, interval.endTime)
                // }}
                {...getIntervalProps({
                  interval,
                  style: intervalStyle,
                })}
              >
                <div className="sticky" style={{leftMargin: '15px', rightMargin: '15px' }}>
                  {dayjs(interval.startTime.$d).format("ddd")}{'-'}{dayjs(interval.startTime.$d).format("M/D")}
                </div>
              </div>
            )
          })}
        </div>
      )
    }}
</CustomHeader>

  );
}

export default CustomDateHeader;
